<script setup lang="ts">
defineProps<{ iconColour: "text-action" | "text-platform-neutral" }>();
</script>

<template>
  <div>
    <div class="flex gap-4 py-2">
      <BaseIcon
        name="check"
        :size="24"
        :class="iconColour"
      />
      <p class="text-sm uppercase font-bold">
        {{ $t("framingUpsell.checkMarks.checkMark1") }}
      </p>
    </div>
    <div class="flex gap-4 py-2">
      <BaseIcon
        name="check"
        :size="24"
        :class="iconColour"
      />
      <p class="text-sm uppercase font-bold">
        {{ $t("framingUpsell.checkMarks.checkMark2") }}
      </p>
    </div>
    <div class="flex gap-4 py-2">
      <BaseIcon
        name="check"
        :size="24"
        :class="iconColour"
      />
      <p class="text-sm uppercase font-bold">
        {{ $t("framingUpsell.checkMarks.checkMark3") }}
      </p>
    </div>
  </div>
</template>
